export default {
  'pdfTemplate.title': 'Gestionar Plantillas',
  'pdfTemplate.form.template': 'Plantilla Relacionada',
  'pdfTemplate.form.form': 'Formulario',
  'pdfTemplate.form.field': 'Campo Tabla Relacionado',
  'pdfTemplate.form.isForInternalChildTemplate': '¿Para Tabla Interna?',
  'pdfTemplate.form.internalTableChildName': 'Tabla Interna',
  'pdfTemplate.select.actionExecutionSteps': 'Acciones - Pasos de Ejecución',
  'pdfTemplate.select.ActionExecutionStepsApproval': 'Acciones - Pasos de Ejecución - Aprobación',
  'pdfTemplate.select.ActionExecutionStepsCompleteInformation':
    'Acciones - Pasos de Ejecución - Completar Información',
  'pdfTemplate.form.isVisibleInDetails': '¿Visible en Vista Detalles de Solicitud?',
  'pdfTemplate.form.fileName': 'Nombre de Fichero',
  'pdfTemplate.select.portrait': 'Vertical',
  'pdfTemplate.select.landscape': 'Horizontal',
  'pdfTemplate.form.paperType': 'Tipo de Papel',
  'pdfTemplate.form.pageOrientation': 'Orientación',
};
